import React from 'react';
import { Textarea } from './textarea';
import clsx from 'clsx';

type CharacterCountProps = React.TextareaHTMLAttributes<HTMLTextAreaElement> & {
  maxLength: number;
  invalid?: boolean;
};

const CharacterCount = React.forwardRef<HTMLTextAreaElement, CharacterCountProps>(
  ({ maxLength, invalid, value, className, ...props }, ref) => {
    const currentLength = typeof value === 'string' ? value.length : 0;
    const remaining = maxLength - currentLength;
    const isOver = remaining < 0;

    return (
      <div data-slot="control">
        <Textarea ref={ref} maxLength={maxLength} invalid={invalid} value={value} className={className} {...props} />
        <p
          className={clsx(
            'text-xs mt-1 text-right',
            isOver ? 'text-danger-600 dark:text-danger-400' : 'text-zinc-500 dark:text-zinc-400'
          )}
          aria-live="polite"
        >
          {currentLength}/{maxLength} characters
        </p>
      </div>
    );
  }
);

CharacterCount.displayName = 'CharacterCount';

export default CharacterCount;
